module.exports = __webpack_public_path__ + "img/Weapon_65.5e8eb0cb.png";